import React from 'react';
import { FaPlus, FaTrash } from 'react-icons/fa';
import { inputClassName } from './FormField';

const NestedListEditor = ({
  label,
  items = [],
  fields,
  onAdd,
  onRemove,
  onChange,
  addLabel = 'Add',
}) => (
  <div className="flex flex-col gap-2">
    <div className="flex justify-between items-center">
      <label className="block text-gray-700 text-sm font-bold">{label}</label>
      <button
        type="button"
        onClick={onAdd}
        className="flex items-center text-sm text-blue-600 hover:text-blue-800"
      >
        <FaPlus className="mr-1" size={10} /> {addLabel}
      </button>
    </div>
    {items.map((item, index) => (
      <div key={index} className="flex gap-2 items-center">
        {fields.map((field) => (
          <input
            key={field.name}
            type={field.type || 'text'}
            value={item[field.name] ?? ''}
            onChange={(e) =>
              onChange(
                index,
                field.name,
                field.type === 'number' ? parseInt(e.target.value, 10) || 0 : e.target.value
              )
            }
            placeholder={field.placeholder || field.label}
            className={`${inputClassName} flex-1`}
          />
        ))}
        <FaTrash
          className="cursor-pointer text-red-500"
          onClick={() => onRemove(index)}
          size={12}
        />
      </div>
    ))}
  </div>
);

export default NestedListEditor;
